import React, { useEffect, useState } from "react"
import { Button } from "@mantine/core"
import { IconShare } from "@tabler/icons-react"
import { captureMobileHandoffShare, type MobileHandoffPage } from "../../analytics"

// One line under a landing page's main button, on phones only: spa.css shows
// .or-mobile-handoff on a narrow or touch-only screen and hides it everywhere
// else, so nothing appears or jumps after load. The agent directions get
// pasted into a coding agent on a computer, while most ad visitors arrive on a
// phone and come back later by searching. So the line names the search to run
// and the short link to type, both plain text with no tracking parameters.
// Where the browser can share, a button sends the page's clean URL (no query)
// to the visitor's own messages or notes.
type Props = {
  // The name a search finds the page by: "Laravel", "WooCommerce", "Bolt".
  // Omitted on the home page, where the search is the project's name alone.
  name?: string
  // The short link config/routes.rb serves for the page: "/laravel". Omitted
  // on the home page, whose address is the host.
  shortPath?: string
  pageKind: MobileHandoffPage
  pageId: string
}

export const MobileHandoff: React.FC<Props> = ({ name, shortPath = "", pageKind, pageId }) => {
  // Feature-detected after mount, so the button never shows where share()
  // would throw (most desktop browsers, older in-app browsers).
  const [canShare, setCanShare] = useState(false)
  useEffect(() => setCanShare(typeof navigator.share === "function"), [])

  const share = () => {
    const url = `${window.location.origin}${window.location.pathname}`
    navigator.share({ title: document.title, url }).then(
      () => captureMobileHandoffShare(pageKind, pageId, "shared"),
      () => captureMobileHandoffShare(pageKind, pageId, "dismissed")
    )
  }

  return (
    <div className="or-mobile-handoff">
      <p>
        <strong>On your phone?</strong> Finish on your computer: search “{name ? `OpenReceive ${name}` : "OpenReceive"}” or open{" "}
        <span className="or-mobile-handoff-link">
          {window.location.host}
          {shortPath}
        </span>
      </p>
      {canShare ? (
        <Button variant="default" size="xs" leftSection={<IconShare size={14} />} onClick={share}>
          Send this page to myself
        </Button>
      ) : null}
    </div>
  )
}
